// Shared identifiers for the two output paths of a CONDITION node.
// Mirror the API's `then` / `otherwise` field names on `ApiWorkflowNode`
// so editor, canvas, and execution view all speak the same vocabulary.

export const THEN = "then" as const
export const OTHERWISE = "otherwise" as const

export type BranchKind = typeof THEN | typeof OTHERWISE

/** Display strings shown to users for each branch. */
export const BRANCH_LABEL: Record<BranchKind, string> = {
  [THEN]: "Then",
  [OTHERWISE]: "Otherwise"
}

/** Display string for the implicit fallback path on a BRANCH node. */
export const BRANCH_OTHERWISE_LABEL = "Otherwise"
